import React, { Component } from "react";
import { connect } from "react-redux";
import * as qs from "query-string";
import { history, isValidStartDate, isValidEndDate } from "../../_helpers";
import { api } from "../../_services";
import { Redirect } from "react-router";
import MenuBar from "../MenuBar";
import FilterMenuBar from "../FilterMenuBar";
import ReportTypeCheckBox from "../ReportTypeCheckBox";
import DateTimePicker from "../DateTimePicker";
import ReportCard from "../ReportCard";
import FontAwesome from "react-fontawesome";
import _ from "lodash";
import { pageReports } from "../../_actions";
import { Row, Col, form, Button, Badge, MenuItem, Dropdown } from "react-bootstrap";
import "./index.css";

class AllReportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      pages: null,
      loading: false,
      filterOpen: false,
      resetFilter: false,
      listLoading: false,
      filtered: false,
      showIDInput: false,
      dropdownOpen: false,
      params: {},
      reloadTimer: null,
    };
  }

  createReportCard = (item, key) => {
    return <ReportCard key={key} item={item} />;
  };

  componentDidMount() {
    this.setState(() => {
      return {
        loading: true
      };
    });
    this.props.pageReports();
    if (this.props.location.search) {
      const params = qs.parse(this.props.location.search);
      this.getAllReports(params);
    } else {
      this.getAllReports();
    }
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.location.search !== nextProps.location.search && nextProps.location.search === "") {
      this.resetFilter();
    }
  };

  componentWillUnmount = () => {
    // clear the interval on unmount.
    clearInterval(this.state.reloadTimer);
  };

  // reload the report list.
  reloadReportsList = () => {
    if (this.props.location.search) {
      const params = qs.parse(this.props.location.search);
      this.getAllReports(params);
    } else {
      this.getAllReports();
    }
  }

  // reload the report list if any pdf is in pending state.
  checkPDFStatus = (data) => {
    const pending = _.find(data, item => {
      return item.pdf_generation_status === "pending" || item.pdf_generation_status === "in_progress";
    });
    if (pending) {
      if (this.state.reloadTimer === null) {
        const reloadTimer = setInterval(this.reloadReportsList, 30000);
        this.setState({ reloadTimer: reloadTimer });
      }
    } else if (this.state.reloadTimer) {
      clearInterval(this.state.reloadTimer);
      this.setState({
        reloadTimer: null,
      });
    }
  }

  /* Retrieve all reports */
  getAllReports = p => {
    this.setState(() => {
      return {
        listLoading: true
      };
    });
    const url = "/api/v1/reports/";
    const params = {};
    if (p) {
      for (const key in p) {
        params[key] = p[key];
      }
      this.setState(() => {
        return {
          params: params
        };
      });
    } else {
      // clear the url params
      if (this.props.location.search) {
        history.push({
          pathname: this.props.location.pathname,
          search: ""
        });
      }
    }
    const errorMsg = "Unable to retrieve reports.";
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      const filtered = this.checkFiltered();
      this.setState(() => {
        return {
          allReportsList: json.results,
          count: json.count,
          page_size: json.page_size,
          num_pages: json.num_pages,
          current_page: json.current_page,
          loading: false,
          listLoading: false,
          filtered: filtered
        };
      });
      this.checkPDFStatus(json.results);
    });
  };

  filterReport = (reset, page) => {
    this.setState(() => {
      return {
        listLoading: true
      };
    });
    const url = "/api/v1/reports/";
    const params = {};
    if (!reset) {
      if (!this.state.params.id) {
        this.setState(() => {
          return {
            showIDInput: false
          };
        });
      }

      for (const key in this.state.params) {
        if (
          this.state.params[key] === "" ||
          (Array.isArray(this.state.params[key]) && this.state.params[key].length === 0)
        ) {
          delete this.state.params[key];
        } else if (this.state.params[key] !== "") {
          params[key] = this.state.params[key];
        }
      }

      if (page) {
        params.page = page;
      } else {
        delete params["page"];
      }
    }
    if (this.checkFiltered() || !reset) {
      const errorMsg = "Unable to retrieve reports.";
      let filtered = false;

      filtered = this.checkFiltered();

      api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
        this.setState(() => {
          return {
            allReportsList: json.results,
            count: json.count,
            page_size: json.page_size,
            num_pages: json.num_pages,
            current_page: json.current_page,
            loading: false,
            listLoading: false,
            filtered: filtered ? true : false
          };
        });
      });
      this.openFilter(false);
    } else if (reset) {
      this.setState(() => {
        return {
          loading: false,
          filtered: reset ? false : true
        };
      });
    }

    const queryParams = api.queryParams(params);
    if (queryParams) {
      history.push({
        pathname: this.props.location.pathname,
        search: "?" + queryParams
      });
    } else {
      history.push({
        pathname: this.props.location.pathname,
        search: ""
      });
    }
  };

  checkFiltered = () => {
    let filtered = false;
    for (const key in this.state.params) {
      if (Array.isArray(this.state.params[key]) && this.state.params[key].length > 0) {
        filtered = true;
      } else if (this.state.params[key]) {
        filtered = true;
      }
    }
    return filtered;
  };

  setStartDate = e => {
    const params = this.state.params;
    params.start_time = e._d ? e._d.toISOString() : "";
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setEndDate = e => {
    const params = this.state.params;
    params.end_time = e._d ? e._d.toISOString() : "";
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setReportType = val => {
    const params = this.state.params;
    params.report_type = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  resetFilter = () => {
    this.setState(() => {
      return {
        resetFilter: true,
        params: {},
        showIDInput: false
      };
    });
    this.getAllReports();
  };

  renderResetBtn = () => {
    if (this.state.filtered === true) {
      return (
        <a className="pull-right link" onClick={() => this.resetFilter()}>
          Reset filters
        </a>
      );
    } else {
      return null;
    }
  };

  selectedOption = e => {
    if (e === "1") {
      this.setState({ redirect: "/createCustomReport" });
    } else if (e === "2") {
      this.setState({ redirect: "/createSensorReport" });
    }
  };

  renderCreateReportButton = () => {
    const { reportCreatePermission } = this.props;
    if (!reportCreatePermission) {
      return null;
    }
    return (
      <div className="reportButton">
        <Dropdown id="dropdown-custom-2">
          <Dropdown.Toggle bsStyle="default" className="btn-primary">
            <FontAwesome className="create-icon" name="plus" />
            Create Report
          </Dropdown.Toggle>
          <Dropdown.Menu className="super-colors" onSelect={this.selectedOption}>
            <MenuItem eventKey="1">Compliance summary report</MenuItem>
            <MenuItem eventKey="2">Sensor data report</MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  renderMainTitle = data => {
    if (!data) {
      return null;
    }

    return (
      <div className="mainTitle">
        <h1>Reports {"(" + this.state.count + ")"}</h1>
      </div>
    );
  };

  isValidStartDate = (current) => isValidStartDate(current, this.state.params.end_time)

  isValidEndDate = (current) => isValidEndDate(current, this.state.params.start_time)

  renderMainContent = data => {
    if (!data) {
      return null;
    }

    const reportCardListToRender = [];
    if (data !== undefined && data.length > 0) {
      _.each(data, (item, key) => {
        reportCardListToRender.push(this.createReportCard(item, key));
      });
    }

    return (
      <div className="mainContent card-list">
        <Row>
          <Col md={3} mdPush={9}>
            <div className={"panel-div filter-column" + (this.state.filterOpen ? " filterOpen" : "")}>
              <div className="filterTitle">FILTER REPORTS {this.renderResetBtn()}</div>
              <form>
                <DateTimePicker
                  timePeriod="From"
                  changeDate={this.setStartDate}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.start_time}
                  isValidDate={this.isValidStartDate}
                />
                <DateTimePicker
                  timePeriod="To"
                  changeDate={this.setEndDate}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.end_time}
                  isValidDate={this.isValidEndDate}
                />
                <ReportTypeCheckBox
                  change={this.setReportType}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.report_type}
                />
                <div className="buttonContainer">
                  <Button className="btn btn-cancel" onClick={() => this.openFilter(false)}>
                    Cancel
                  </Button>
                  <Button className="btn-filter" bsStyle="primary" onClick={() => this.filterReport()}>
                    Filter
                  </Button>
                </div>
              </form>
            </div>
          </Col>
          <Col md={9} mdPull={3}>
            <div className="buttonContainer margin-btm filter-btn-con">
              <Button onClick={() => this.openFilter(true)} bsStyle="primary">
                Filter {this.renderFilterBadge()}
              </Button>
            </div>
            {this.state.listLoading ? (
              <div className="empty-list">
                <div className="loading2" />
              </div>
            ) : null}
            <div className={this.state.listLoading ? "hide" : ""}>
              {reportCardListToRender.length > 0 ? reportCardListToRender : <div className="empty-list">No Result</div>}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  renderFilterBadge = () => {
    const obj = this.state.params;
    let count = 0;
    let key;
    for (key in obj) {
      if (obj.hasOwnProperty(key) && (Array.isArray(obj[key]) && obj[key].length > 0)) {
        count++;
      } else if (obj.hasOwnProperty(key) && obj[key] !== "") {
        count++;
      }
    }

    if (this.state.filtered === true) {
      return <Badge>{count} &times;</Badge>;
    } else {
      return null;
    }
  };

  openFilter = opened => {
    if (opened) {
      this.setState(() => {
        return {
          filterOpen: true
        };
      });
    } else {
      this.setState(() => {
        return {
          filterOpen: false
        };
      });
    }
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  render() {
    const data = this.state.allReportsList;
    if (this.state.redirect) {
      return <Redirect push to={this.state.redirect} />;
    }
    if (this.state.loading === false) {
      return (
        <div>
          <MenuBar />
          <FilterMenuBar />
          <div className="mainPanelCon">
            <div className="container">
              {this.renderMainTitle(data)}
              {this.renderCreateReportButton()}
              {this.renderMainContent(data)}
            </div>
          </div>
        </div>
      );
    } else {
      return <div>{this.renderLoadingPage()}</div>;
    }
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { reportCreatePermission } = state.report;
  return {
    user,
    reportCreatePermission
  };
}

export default connect(mapStateToProps, { pageReports })(AllReportPage);



// WEBPACK FOOTER //
// ./src/_components/AllReportPage/index.js